<template>
  <div class="min-h-screen bg-gray-200 antialiased xl:flex xl:flex-col xl:h-screen">
    <the-header class="xl:flex-shrink-0"/>
    <slot/>
  </div>
</template>

<script>
import TheHeader from '@/components/header/TheHeader';

export default {
  name: 'LayoutDefault',
  components: {
    TheHeader
  }
};
</script>
